import React, {useState} from "react";
import "./MessageCardStyles.scss";

type ModalProps = {}

export const NoMessageCard = (props: ModalProps) => {
    return (
        <div className='message' style={{alignItems: 'center', width: '90vw'}}>
            <div>Диалог пуст</div>
        </div>
    )
}